export enum Marketplace {
 AVITOMA = 'AVITOMA',
 COCHES = 'COCHES',
 COROTOS = 'COROTOS',
 CUSTOJUSTO = 'CUSTOJUSTO',
 FINCARAIZ = 'FINCARAIZ',
 FOTOCASA = 'FOTOCASA',
 KUFAR = 'KUFAR',
 LEBONCOIN = 'LEBONCOIN',
 TESTSITE = 'TESTSITE',
 MILANUNCIOS = 'MILANUNCIOS',
 SEGUNDAMANOMX = 'SEGUNDAMANOMX',
 SUBITO = 'SUBITO',
 TAYARA = 'TAYARA',
 SEGUNDAMANO = 'SEGUNDAMANO',
 WILLHABEN = 'WILLHABEN',
}
